import React, { useState, useEffect, useRef } from 'react';
import "./heroslide.scss";
// import tmdbApi, { category, movieType } from "../../api/tmdbApi";
import apiConfig from '../../api/apiConfig';
import axios from 'axios';
import SwipeCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate, Link } from 'react-router-dom';
import Button, { OutlineButton } from "../button/Button";
import Modal, { ModalContent } from "../../components/modal/Modal"

const HeroSlide = () => {
    SwipeCore.use([Autoplay]);
    const [movieItems, setMovieItems] = useState([]);

    useEffect(() => {
        const getMovies = async () => {
            // const params = { page: 1 }
            try {
                // const response = await tmdbApi.getMoviesList(movieType.popular, { params });
                const response = await axios.get('https://api.themoviedb.org/3/movie/popular?api_key=088f4df643022cbbe2a297babd84490c');
                setMovieItems(response.data.results.slice(0, 5));
                // console.table(response.data.results[0]);
            } catch (error) {
                console.log(error);
            }
        }
        getMovies();
    }, [])
    return (
        <div className='hero-slide'>
            <Swiper
                modules={[Autoplay]}
                grabCursor={true}
                spaceBetween={0}
                slidesPerView={1}
                autoplay={{ delay: 3000 }}
            >
                {
                    movieItems.map((item, index) => (
                        <SwiperSlide key={index}>
                            {({ isActive }) => (
                                // <img src={apiConfig.originalImage(item.backdrop_path)} alt="" />
                                <HeroSlideItem item={item} className={`${isActive ? 'active' : ''}`} />
                            )}
                        </SwiperSlide>
                    ))
                }
            </Swiper>

            {
                movieItems.map((item, index) => <TrailerModal key={index} item={item} />)
            }
        </div>
    )
}

const HeroSlideItem = props => {// eslint-disable-next-line
    const navigate = useNavigate();
    const item = props.item;
    const background = apiConfig.originalImage(item.backdrop_path ? item.backdrop_path : item.poster_path);

    const setModalActive = async () => {
        console.log("called")
        const modal = document.querySelector(`#modal_${item.id}`);
        const videos = await axios.get(`https://api.themoviedb.org/3/movie/${item.id}/videos?api_key=088f4df643022cbbe2a297babd84490c`);
        console.log(videos);
        if (videos.data.results.length > 0) {
            const videoSrc = `https://www.youtube.com/embed/${videos.data.results[0].key}`;
            console.log(videoSrc);
            modal.querySelector('.modal__content > iframe').setAttribute('src', videoSrc);
        } else {
            console.log('Not');
            modal.querySelector(',modal__content').innerHTML = 'Trailer is NOT available';
        }

        modal.classList.toggle('active');
    }

    return (
        <div
            className={`hero-slide__item ${props.className}`}
            style={{ backgroundImage: `url(${background})` }}
        >
            <div className="hero-slide__item__content container">
                <div className="hero-slide__item__content__info">
                    <h2 className="title">{item.title}</h2>
                    <div className="overview">{item.overview}</div>
                    <div className="btns">
                        <Link to={`/movie/${item.id}`}>
                            <Button>
                                Watch Now
                            </Button>
                        </Link>

                        {/* <Link to={`/`}> */}
                        <OutlineButton onClick={setModalActive}>
                            Watch Trailer
                        </OutlineButton>
                        {/* </Link> */}
                    </div>
                </div>
                <div className="hero-slide__item__content__poster">
                    <img src={apiConfig.w500Image(item.poster_path)} alt="" />
                </div>
            </div>
        </div>
    )
}

const TrailerModal = props => {
    const item = props.item;
    const iframeRef = useRef(null);

    const onClose = () => iframeRef.current.setAttribute('scr', '');

    return (
        <Modal active={false} id={`modal_${item.id}`}>
            <ModalContent onClose={onClose}>
                <iframe ref={iframeRef} width="100%" height="500px" title='Trailer'></iframe>
            </ModalContent>
        </Modal>
    )
}

export default HeroSlide